<template>
    <div
        class="dropdown border-default bg-primary-white start-date-dropdown"
        :ref="'dropdownWrap'"
        :class="{
            '': !startDate,
            '': startDate
        }"
        id="dropdown-container"
    >
        <button
            id="start-date"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 position-absolute top-0 left-0 bg-none"
            :class="{
                'dropdown-toggle': !startDate
            }"
            ref="dropdown"
        >
            <CalendarIcon></CalendarIcon>
            <span class="subcaption text-primary-black content content me-2" :class="{ 'subcaption-strong': startDate }">
                <span>{{ startDate ? displayValue : store.contents.startDate }}</span>
            </span>

            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
        </button>
        <div class="dropdown-menu calendar-dropdown-menu shadow-4 pt-0 px-2 pb-2 min-w-100" @click.stop>
            <Datepicker
                :value="startDate"
                :get-default-date="getDefaultDate"
                :get-available-dates="getAvailableDates"
                :show-other-months="true"
                :contents="store.contents.datepicker"
                :key="state.key"
                :store="store"
                :show-next-season-button="store.state.showNextSeasonButton"
                @change="change"
            ></Datepicker>
        </div>

    </div>
</template>

<script>
import moment from 'moment'
import CalendarIcon from '@se/components/svg/se/calendar/index.vue'
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import Datepicker from '@se/components/datepicker.vue'
import { onClickOutside } from '@vueuse/core'

export default {
    name: 'StartDate',
    components: {
        Datepicker,
        CalendarIcon,
        ArrowUp,
        ArrowDown
    },
    props: {
        store: Object,
        events: Object
    },
    data: function () {
        return {
            state: {
                key: 0
            }
        }
    },
    computed: {
        displayValue() {
            if (this.startDate) {
                return moment(this.startDate).format('DD/MM/YYYY')
            }
        },
        startDate() {
            return this.store.data.selected.startDate
        }
    },
    methods: {
        change: function (date) {
            var self = this
            var startDate = moment(date).format('YYYY-MM-DD')
            this.store.libs.se.batch(function () {
                self.store.libs.se.setFieldValue('beginDate', startDate)
                self.store.libs.se.setFieldValue('endDate', undefined)
            })
            $(this.$refs.dropdown).dropdown('hide')
            this.$emit('select')
        },
        getDefaultDate: function (dates) {
            if (dates.length === 0) {
                return null
            }
            return new Date(dates[0])
        },
        getAvailableDates: function (monthStr, nextMonth) {
            return this.store.libs.se.requestStartDates(monthStr, nextMonth)
        },
        clear: function () {
            var self = this
            this.store.libs.se.batch(function () {
                self.store.libs.se.setFieldValue('beginDate', undefined)
                self.store.libs.se.setFieldValue('endDate', undefined)
            })
            this.showDropdown()
        },
        showDropdown: function () {
            $(this.$refs.dropdown).dropdown('show')
        }
    },
    beforeDestroy: function () {
        $(this.$refs.dropdown).dropdown('dispose')
    },
    mounted: function () {
        var self = this
        this.events.on('show', function () {
            self.showDropdown()
        })
        this.events.on('hide', function () {
            $(self.$refs.dropdown).dropdown('hide')
        })
        var dropdownWrap = $(this.$refs.dropdownWrap)
        dropdownWrap.on('show.bs.dropdown', function () {
            try {
                self.$emit('show')
                self.state.key++
            } catch (e) {}
        })
        dropdownWrap.on('shown.bs.dropdown', function () {
            self.$emit('shown')
            setTimeout(function () {
                // $(self.$refs.dropdownWrap).addClass('show')
            }, 1000)
        })
        dropdownWrap.on('hide.bs.dropdown', function () {
            self.$emit('hide')
        })
        dropdownWrap.on('hidden.bs.dropdown', function () {
            self.$emit('hidden')
        })

        onClickOutside(this.$refs.dropdownWrap, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
.arrow-up {
    display: flex;
}

.arrow-down {
    display: none;
}

.start-date-dropdown.show .arrow-down {
    display: flex;
}

.start-date-dropdown.show .arrow-up {
    display: none;
}
</style>
